import { useState } from 'react';

import useDebouncedCallback from './use-debounced-callback';

export function useTriggerRender(): () => void {
  const [, setValue] = useState({});

  return useDebouncedCallback(() => setValue({}), 10);
}
